<template>
  <div>
    <v-btn small @click="handleShowForm">
      Add Log item
    </v-btn>

    <v-dialog v-model="showModal" max-width="800" persistent>
      <v-card v-if="!caseInfo && showModal">
        Loading...
      </v-card>
      <v-card v-else>
        <v-card-title class="headline">Add service log item</v-card-title>
        <v-card-text>
          <v-form v-model="isValid" ref="form">
            <service-select v-model="serviceId"
                            :rules="serviceRules"
                            :serviceFilter="filterService"/>
            <v-radio-group v-model="event" row>
              <v-radio label="Requested" value="ChangeRequested"/>
              <v-radio label="Executed" value="ChangeExecuted"/>
            </v-radio-group>
            <number-input v-model="quantityChange"
                          label="Quantity change"
                          :min-value="1"
                          :max-value="100"/>

            <date-time-input
              label="Date and time"
              :required="true"
              v-model="occurredAt"/>

            <v-text-field
              label="Comment"
              v-model="comment"/>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleFormSubmit">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import ServiceSelect from '../../Ui/mcc/ServiceSelect'
    import NumberInput from '../../Ui/NumberInput'
    import {notificationService} from '../../../application'
    import DateTimeInput from "../../Ui/DateTimeInput";

    export default {
        name: 'add-case-service-log-form',
        components: {
            ServiceSelect,
            NumberInput,
            DateTimeInput
        },
        props: {
            caseId: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                isValid: false,
                showModal: false,
                serviceId: null,
                quantityChange: 1,
                occurredAt: new Date().toISOString(),
                comment: '',
                event: 'ChangeRequested',
                serviceRules: [
                    v => !!v || 'Can\'t be null'
                ],
            }
        },
        computed: {
            caseInfo() {
                return this.$store.getters.getCaseInfoById(this.caseId);
            },
            availableServicesForClient() {
                if (!this.caseInfo || !this.caseInfo.response) { // case not loaded yet
                    return []
                }

                return this.$store.getters.getClientServices(this.caseInfo.response.clientId);
            }
        },
        mounted() {
            this.fetchCaseByIdIfRequired(this.caseId);
            this.fetchInitDataIfRequired()
        },
        watch: {
            showModal() {
                if (!this.showModal) {
                    this.resetForm()
                }
            }
        },
        methods: {
            ...mapActions({
                addCaseServiceLog: 'addCaseServiceLog',
                fetchCaseByIdIfRequired: 'fetchCaseByIdIfRequired',
                fetchInitDataIfRequired: 'fetchInitDataIfRequired'
            }),
            handleShowForm() {
                this.showModal = true
            },
            handleHideForm() {
                this.showModal = false
            },
            handleFormSubmit() {
                if (!this.$refs.form.validate()) {
                    return
                }
                this
                    .addCaseServiceLog({
                        caseId: this.caseId,
                        serviceId: this.serviceId,
                        event: this.event,
                        quantityChange: this.quantityChange,
                        occurredAt: this.occurredAt,
                        comment: this.comment
                    })
                    .then(() => {
                        notificationService.info('Log record created');
                        this.showModal = false
                    })
                    .catch(e => {
                        notificationService.error('Operation failed');
                        throw e
                    })
            },
            resetForm() {
                this.serviceId = null;
                this.quantityChange = 1;
                this.occurredAt = new Date().toISOString();
                this.comment = '';
                this.event = 'ChangeExecuted'
            },
            filterService(service) {
                if (this.availableServicesForClient.indexOf(service.id) < 0) {
                    return false
                }

                return true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/AddCaseServiceLogForm.vue